var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.845,
    height: 20.522,
    viewBox: "0 0 17.845 20.522",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Refresh",
    d: "M39.761,20.461a8.974,8.974,0,0,1,.926-17.888V.158a.173.173,0,0,1,.281-.122l4.971,3.651a.153.153,0,0,1,0,.247L40.968,7.585a.175.175,0,0,1-.281-.122V5.053a6.5,6.5,0,1,0,6.522,7.536,1.236,1.236,0,0,1,2.443.373,8.987,8.987,0,0,1-9.891,7.5Z",
    transform: "translate(-31.818 0.002)",
    fill: "#787f88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReloadIcon);
export default __webpack_public_path__ + "static/media/reload-icon.d3af7f9394891636576eca1a9f303f00.svg";
export { ForwardRef as ReactComponent };